// import React, { useCallback, useEffect } from 'react';
// import { Provider, useSelector } from 'react-redux';

// import { map } from './Map';
// import store from '../store';
// import StatusView from './StatusView';

// const PositionsMap = ({ positions }) => {
//   const id = 'positions';

//   const history = useHistory();
//   const devices = useSelector(state => state.devices.items);

//   const createFeature = (devices, position) => {
//     const device = devices[position.deviceId] || null;
//     return {
//       deviceId: position.deviceId,
//       name: device ? device.name : '',
//       category: device && (device.category || 'default'),
//     }
//   };

//   const onMouseEnter = () => map.getCanvas().style.cursor = 'pointer';
//   const onMouseLeave = () => map.getCanvas().style.cursor = '';

//   const onClickCallback = useCallback(event => {
//     const feature = event.features[0];
//     let coordinates = feature.geometry.coordinates.slice();
//     while (Math.abs(event.lngLat.lng - coordinates[0]) > 180) {
//       coordinates[0] += event.lngLat.lng > coordinates[0] ? 360 : -360;
//     }

//     const placeholder = document.createElement('div');

//     ReactDOM.render(
//       <Provider store={store}>
//         <StatusView deviceId={feature.properties.deviceId} onShowDetails={positionId => history.push(`/position/${positionId}`)} />
//       </Provider>,
//       placeholder
//     );

//     new mapboxgl.Popup({
//       offset: 25,
//       anchor: 'top'
//     })
//       .setDOMContent(placeholder)
//       .setLngLat(coordinates)
//       .addTo(map);
//   }, [history]);

//   useEffect(() => {
//     map.addSource(id, {
//       'type': 'geojson',
//       'data': {
//         type: 'FeatureCollection',
//         features: [],
//       }
//     });
//     map.addLayer({
//       'id': id,
//       'type': 'symbol',
//       'source': id,
//       'layout': {
//         'icon-image': '{category}',
//         'icon-allow-overlap': true,
//         'text-field': '{name}',
//         'text-allow-overlap': true,
//         'text-anchor': 'bottom',
//         'text-offset': [0, -2],
//         'text-font': ['Roboto Regular'],
//         'text-size': 12,
//       },
//       'paint': {
//         'text-halo-color': 'white',
//         'text-halo-width': 1,
//       },
//     });

//     map.on('mouseenter', id, onMouseEnter);
//     map.on('mouseleave', id, onMouseLeave);
//     map.on('click', id, onClickCallback);

//     return () => {
//       Array.from(map.getContainer().getElementsByClassName('mapboxgl-popup')).forEach(el => el.remove());

//       map.off('mouseenter', id, onMouseEnter);
//       map.off('mouseleave', id, onMouseLeave);
//       map.off('click', id, onClickCallback);

//       map.removeLayer(id);
//       map.removeSource(id);
//     };
//   }, [onClickCallback]);

//   useEffect(() => {
//     map.getSource(id).setData({
//       type: 'FeatureCollection',
//       features: positions.map(position => ({
//         type: 'Feature',
//         geometry: {
//           type: 'Point',
//           coordinates: [position.longitude, position.latitude],
//         },
//         properties: createFeature(devices, position),
//       }))
//     });
//   }, [devices, positions]);

//   return null;
// }

// export default PositionsMap;

import React from "react";
import { GoogleMap, Marker } from "@react-google-maps/api";
import { Provider, useSelector } from "react-redux";
import store from "../store";
import StatusView from "./StatusView";
import { InfoWindow } from "@react-google-maps/api";
import { useHistory } from 'react-router-dom';



const getIconForMarker= (position, category)=> {
const topView = true;
const availableImageList = [];
  availableImageList.push("car");
  availableImageList.push("truck");
  availableImageList.push("motorcycle");
  availableImageList.push("bus");
  availableImageList.push("person");
  availableImageList.push("arrow");
  availableImageList.push("tractor");
  availableImageList.push("pickup");

let categoryName = category || "car";
        if (!availableImageList.some((attribute) => attribute === category)){
            categoryName = "car";
            }
        categoryName = "category_" + (topView ? "top_" : "") + categoryName;

 if (!position || !position.id)
            return categoryName + "_running";

  if(position.attributes && position.attributes.motion){
    return categoryName + "_running";
  }
  if(position.attributes && position.attributes.ignition){
   return categoryName + "_idle" ;
  }
   return categoryName + "_stopped" ;

}


const MapMarker = (props) => {

  const history = useHistory();

  const [mapMarker, setMapMarker] = React.useState(null);
  const { markerData, scaleSize } = props;
  const onLoad = (mapMarker) => {
    setMapMarker(mapMarker);
  };

  const onClick = () => {
    const { isInfoOpen, isSelected, markerData, onClick} = props;

    const isOpen = isSelected ? !isInfoOpen : true;

    onClick(isOpen, markerData.id);
  };

  const renderInfoWindow = (markerId) => {
    const { isInfoOpen, isSelected, markerData } = props;
    // const { mapMarker } = this.state;

    if (!isInfoOpen || !isSelected || !mapMarker) {
      return null;
    }

    return (
      <InfoWindow anchor={mapMarker} zIndex={1}>
         {/* <p> Hi its working </p>  */}
      <StatusView deviceId={markerData.id} markerData={markerData} onShowDetails={positionId => history.push(`/position/${positionId}`)} />
      </InfoWindow>
    );
  };

  return (
    <Marker
      onLoad={onLoad}
      onClick={onClick}
      position={markerData.position}
      options={{
        icon: {
         path: window.google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                        scale: (scaleSize || 5),
                        fillColor: markerData.markerColor,
                        strokeColor: markerData.markerColor,
                        fillOpacity: 1,
                        strokeWeight: 2,
                        rotation: markerData.course,
        },
      }}
    >
      {renderInfoWindow(markerData.id)}
    </Marker>
  );
};


const getIconBackgroundColor= (position)=> {
  if(!position || !position.id){
    return 'black';
  }

  if(position.attributes && position.attributes.motion){
    return '#00C49F';
  }

  if(position.attributes && position.attributes.ignition){
    return '#FFBB28';
  }

  return '#E82C38';
}

const PositionsMap = ({ scaleSize, positions }) => {
  const id = "positions";
  const [isInfoOpen, setIsInfoOpen] = React.useState(null);
  const [selectedMarkerId, setSelectedMarkerId] = React.useState(null);

  // const history = useHistory();
  const devices = useSelector((state) => state.devices.items);

  const createFeature = (position) => {
    const device = devices[position.deviceId] || null;
    return {
    //   id: position.deviceId,
     ...position,
    //  id: position.deviceId,
      name: device ? device.name : "",
      icon: device && (device.category || "default"),
      position: {
        lat: position.latitude,
        lng: position.longitude,
      },
      course: position.course,
      markerColor: getIconBackgroundColor(position)
    };
  };

  const onClick = (isInfoOpen, selectedMarkerId) => {
    setIsInfoOpen(isInfoOpen);
    setSelectedMarkerId(selectedMarkerId);
  };

  return (
    <div>
      {positions.map((location) => {
        const markerData = createFeature(location);
        return (
          <MapMarker
            key={markerData.id}
            markerData={markerData}
            isSelected={markerData.id === selectedMarkerId}
            isInfoOpen={markerData.id === selectedMarkerId && isInfoOpen}
            onClick={onClick}
            scaleSize={scaleSize}
          />
        );
      })}
    </div>
  );
};

export default PositionsMap;
